import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "players-report__wrapper" }
const _hoisted_2 = { class: "players-report__block-content players-report__block-content_green" }
const _hoisted_3 = { class: "players-report__block-content players-report__block-content_blue" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageContentBlock = _resolveComponent("PageContentBlock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageContentBlock, {
      title: "Online",
      class: "players-report__block"
    }, {
      "block-content": _withCtx(() => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.totalPlayersOnlineCount), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_PageContentBlock, {
      title: "Players",
      class: "players-report__block"
    }, {
      "block-content": _withCtx(() => [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.totalPlayersCount), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}